<div class="grid-view-main-container">
  <div class="table-container">
    <table class="table" *ngIf="data">
      <thead class="thead-dark sticky-top">
        <th class="column-selector-container" *ngIf="showColumnSelector">
          <div  class="table-heading border-0" (click)="openColumnOptions($event)">
            <ion-icon name="caret-down-circle-outline" class="table-header-select ion-no-padding"></ion-icon>
          </div>
        </th>
        <th class="column-selector-container px-0 ps-0" *ngIf="multiSelectProperty">
            <div class="table-heading px-0 border-0">
              <input
                type="checkbox"
                class="align-middle"
                [checked]="isAllSelected()"
                (change)="toggleSelectAllRows($event)"
              >
            </div>
          </th>
        <th *ngIf="shouldShowColumn('itineraryId')" class="id-column">
          <div class="table-heading">
            <p class="text mb-0">Itinerary ID</p>
            <ng-container>
              <button class="sort-btn" (click)="sortData('itineraryId')">
                <ion-icon
                  [name]="sortOrder['itineraryId'] === 'asc' ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
              </button>
            </ng-container>
          </div>
        </th>
        <th *ngIf="shouldShowColumn('itineraryName')">
          <div class="table-heading">
            <p class="text mb-0">Name</p>
          </div>
        </th>
        <th *ngIf="shouldShowColumn('locationArray')">
          <div class="table-heading">
            <p class="text mb-0">Destinations</p>
          </div>
        </th>
        <th *ngIf="shouldShowColumn('totalDays')" class="no-of-days-column">
          <div class="table-heading">
            <p class="text mb-0">Nights</p>
            <ng-container>
              <button class="sort-btn" (click)="sortData('totalDays')">
                <ion-icon
                  [name]="sortOrder['totalDays'] === 'asc' ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
              </button>
            </ng-container>
          </div>
        </th>
        <th *ngIf="shouldShowColumn('approxCost')" class="column-width-130">
          <div class="table-heading">
            <p class="text mb-0">Approx Cost</p>
          </div>
        </th>
        <th *ngIf="shouldShowColumn('imagePath')" class="status-column">
          <div class="table-heading">
            <p class="text mb-0">Banner Image</p>
          </div>
        </th>
        <th *ngIf="shouldShowColumn('itineraryType')" class="column-width-70">
          <div class="table-heading">
            <p class="text mb-0">Itinerary Type</p>
          </div>
        </th>
        <th *ngIf="shouldShowColumn('showInWebsite')" class="column-width-70">
          <div class="table-heading">
            <p class="text mb-0">Show In Website</p>
          </div>
        </th>
        <th *ngIf="shouldShowColumn('status')" class="status-column">
          <div class="table-heading">
            <p class="text mb-0">Status</p>
          </div>
        </th>
        <th class="options-column">
          <div class="table-heading border-0">
            <p class="text mb-0">Options</p>
          </div>
        </th>
      </thead>
    
      <tbody>
        <tr *ngFor="let item of data; index as i">
          <td></td>
          <td *ngIf="multiSelectProperty" class="px-0">
            <div class="px-0 ps-0">
              <input
                type="checkbox"
                class="align-middle"
                [checked]="isRowSelected(item)"
                (change)="toggleSelectRow($event, item)"
              >
            </div>
          </td>
          <td *ngIf="shouldShowColumn('itineraryId')" (click)="openItineraryView(item)"><span class="clickable-text">{{item.itineraryId}}</span></td>
          <td *ngIf="shouldShowColumn('itineraryName')">{{item.itineraryName}}</td>
          <td *ngIf="shouldShowColumn('locationArray')">
            <span>
              <ion-button class="location-icon"><ion-icon name="pin-outline"></ion-icon></ion-button>
            </span>

            {{item.locationArray}}</td>
          <td *ngIf="shouldShowColumn('totalDays')">{{item.totalDays}}</td>
          <td *ngIf="shouldShowColumn('approxCost')" style="padding-top: 4px; padding-bottom: 2px;">
            <div class="">
              <div class="input-container">
                <app-cost-currency-input class="cost-input-container"
                  [value]="item.approxCost || {amount: '', currency: 'INR'}"
                  (valueChange)="onCostChanged($event, item)"
                  [currencies]="['INR','USD','EUR','GBP','AUD','CAD','JPY']">
                </app-cost-currency-input>
              </div>
            </div>
          </td>
          <td *ngIf="shouldShowColumn('imagePath')">
            <div class="text-center">
              <div class="d-flex gap-1">
                <ng-container *ngIf="item.imagePath">
                  <p class="clickable-text mb-0" (click)="viewBannerImage(item)">View \ </p>
                </ng-container>
                <ng-container>
                  <p class="clickable-text mb-0" (click)="uploadBannerImage(item)">Upload</p>
                </ng-container>
              </div>
            </div>
          </td>
          <td *ngIf="shouldShowColumn('itineraryType')">
            <div class="status-container">
              <select class="input-status status-dropdown" [ngModel]="item.itineraryType" (change)="itineraryTypeChanged($event, item)" [class]="getStatusColor(item.itineraryType)">
                <option value="'' || null" hidden>Select type</option>
                <option *ngFor="let type of itineraryTypeLov"
                  [value]="type.key">{{type.name}}</option>
              </select>
            </div>
          </td>
          <td *ngIf="shouldShowColumn('showInWebsite')">
            <div class="text-center">
              <input type="checkbox" name="" id="" [checked]="item.showInWebsite" (input)="showInWebsiteChanged($event, item)">
            </div>
          </td>
          <td *ngIf="shouldShowColumn('status')">
            <div class="status-container">
              <select class="input-status status-dropdown" [ngModel]="item.status" (change)="statusChanged($event, item)" [class]="getStatusColor(item.status)">
                <option *ngFor="let status of inventoryItineraryStatusLov" [ngClass]="{'d-none': status.disabled}"
                  [value]="status.key">{{status.name}}</option>
              </select>
            </div>
          </td>

          <td class="options-column">
            <div class="options text-center" (click)="openPassengerOptionPopover($event, item)">
              <ion-icon name="ellipsis-horizontal-outline"></ion-icon>
            </div>
          </td>
    
        </tr>
        <tr *ngIf="data.length === 0">
          <td colspan="9" class="text-center">
            <p class="my-2">No Results Found!</p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  
  
  
  <div class="w-100 paginations-container" *ngIf="!hidePaginations">
    <div class="d-flex justify-content-between w-100">
      <div class="d-flex align-items-center">
        <div class="select-container">
          <select name="" id="" class="records-selector" [(ngModel)]="paginationSettings.pageSize" (change)="onPageSizeChange()">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
          </select>
        </div>
        <div class="label-container">
          <p class="label">Showing {{noOfRows}} records of {{paginationSettings.totalCount}}</p>
        </div>
      </div>
  
      <div class="control-btns">
        <div class="buttons-row">
          <!-- Back btn -->
          <ion-button class="control-btn" (click)="onPrevious()" [disabled]="paginationSettings.pageNumber === 1">
            <ion-icon name="chevron-back-outline"></ion-icon>
          </ion-button>
  
          <!-- pages buttons list -->
          <ion-button 
            class="control-btn" 
            *ngFor="let page of visiblePages" 
            (click)="onPageChange(page)" 
            [class.active]="page === paginationSettings.pageNumber">
            {{page}}
          </ion-button>
  
          <!-- Forward btn -->
          <ion-button class="control-btn" (click)="onNext()" [disabled]="paginationSettings.pageNumber === paginationSettings.totalPages">
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </ion-button>
        </div>
      </div>
    </div>
  </div>
</div>